import HttpFactory from '../factory'
import { EncounterEntityTypeEnum, EncounterTypeEnum } from '../types/encounter'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import type { GenderEnum } from '../types/patient/patient'
dayjs.extend(duration)

export interface Entity {
  entityType: keyof typeof EncounterEntityTypeEnum
  entityId: string
  additionalInformations?: {
    name: string
    profession: string
    gender: GenderEnum
    relation: string
  }
}
export interface RawEvent {
  id: string
  patientId: string
  startedAt: Date
  endedAt: Date | null
  episodeOfCareId: string
  parentId: string
  type: string // enum
  updatedAt: Date | null
  actor: {
    id: string
    type: keyof typeof EncounterEntityTypeEnum
  }
  data: {
    initiatedBy?: Entity //TODO make it mandatory when backend implement it
    comment: string | null
    id: string
    status: string // enum
    type: keyof typeof EncounterTypeEnum
    reason: {
      use: string
      value: string
    }
    participants: Entity[]
    severity: number | null
    statusReason: string
    actions: any
    incidentId: string
    [key: string]: any
  }
}

class TimelineModule extends HttpFactory<any[]> {
  private RESOURCE = '/events/patients'

  async get(
    patientId?: string,
    nextPageUrl?: string,
    abortSignal?: AbortSignal | undefined,
  ): Promise<{ items: RawEvent[]; nextPageUrl: string }> {
    const data = await this.call<{ items: RawEvent[]; nextPageUrl?: string }>(
      'GET',
      nextPageUrl
        ? `${this.RESOURCE}${nextPageUrl}`
        : `${this.RESOURCE}?patientId=${patientId}&orderDirection=desc&pageSize=100`,
      undefined,
      undefined,
      abortSignal,
    )
    return data
  }

  async getIncident(id: string): Promise<any> {
    const data = await this.call('GET', `/events/${id}`)
    return data
  }
}

export default TimelineModule
